export const MessageType = {
  GET_SOURCE: 'getSource',
  GET_CODE: 'get-aipage-code-by-commit-id',
  GET_COMMIT_INFO: 'get-aipage-commit-info',
};
